// The web's calls through the generated client: a failure with its status (404 and 403 mean different things on a
// page), and the short forms of times and hashes the pages show.

/** An API failure with its status (404 and 403 mean different things on these pages). */
export class ApiFailure extends Error {
  readonly status: number;
  readonly code?: string;
  constructor(status: number, message: string, code?: string) {
    super(message);
    this.status = status;
    this.code = code;
  }
}

export async function call<T>(p: Promise<{ data?: T; error?: unknown; response: Response }>): Promise<T> {
  let r: { data?: T; error?: unknown; response: Response };
  try {
    r = await p;
  } catch {
    throw new ApiFailure(0, 'The API is unreachable.');
  }
  if (r.error !== undefined || !r.response.ok) {
    const e = r.error as { message?: string; error?: string } | undefined;
    throw new ApiFailure(r.response.status, e?.message ?? `The API answered ${r.response.status}.`, e?.error);
  }
  return r.data as T;
}

/** "3 min ago", "in 23 h". */
export function relative(iso: string | null, now = Date.now()): string {
  if (!iso) return '—';
  const d = new Date(iso).getTime() - now;
  const abs = Math.abs(d);
  const unit =
    abs < 60_000
      ? `${Math.max(1, Math.round(abs / 1000))} s`
      : abs < 3_600_000
        ? `${Math.round(abs / 60_000)} min`
        : abs < 86_400_000
          ? `${Math.round(abs / 3_600_000)} h`
          : `${Math.round(abs / 86_400_000)} d`;
  return d < 0 ? `${unit} ago` : `in ${unit}`;
}

export const short = (h: string | null | undefined) => (h ? h.replace(/^sha256:/, '').slice(0, 12) : '—');

/** A readable message from an API error body (or the status when there is none). */
export function errorMessage(error: unknown, response?: Response): string {
  if (error && typeof error === 'object' && 'message' in error && typeof error.message === 'string')
    return error.message;
  return response ? `The API answered ${response.status}.` : 'The API is unreachable.';
}

/** "just now", "3 min ago". */
export function ago(iso: string | null | undefined, now = Date.now()): string {
  if (!iso) return '—';
  const s = Math.max(0, Math.round((now - new Date(iso).getTime()) / 1000));
  if (s < 10) return 'just now';
  if (s < 60) return `${s} s ago`;
  if (s < 3600) return `${Math.round(s / 60)} min ago`;
  if (s < 86_400) return `${Math.round(s / 3600)} h ago`;
  return `${Math.round(s / 86_400)} d ago`;
}
